import React from 'react';
import {
    Select,
    MenuItem,
} from '@material-ui/core';
import {func, string} from 'prop-types';

const defaultValue = 'INACTIVE';

export const getValue = (val: any) => {
    if (val)
        return val;
    
    return defaultValue;
};

const AccountStatusSelector = (props: any) => {
    const {
        onChange,
        value,
        variant,
    } = props;
    
    return (
        <Select
            id="account-status"
            onChange={onChange}
            value={getValue(value)}
            variant={variant}
        >
            <MenuItem value="ACTIVE">Active</MenuItem>
            <MenuItem value="INACTIVE">Inactive</MenuItem>
        </Select>
    );
};

AccountStatusSelector.propTypes = {
    onChange: func.isRequired,
    value: string.isRequired,
    variant: string.isRequired,
};

export default AccountStatusSelector;

